import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { fetchServicesThunk } from './slices/serviceSlice';
import { fetchAdmin, fetchUser } from './slices/userSlice';

const useFetchReduxUserData = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchUser());
    dispatch(fetchAdmin());
    dispatch(fetchServicesThunk());
  }, [dispatch]);
};

export default useFetchReduxUserData;
